import { withTracker } from '@/tracker';
import SEO from '@/components/seo';
import Hero from '@/components/press/hero';
import Story from '@/components/press/story';

function Press () {
  return (
    <>
      <SEO
        title="Bidali Press Kit"
        description="Everything you need to write your next story." />
      <Hero />
      <Story />
    </>
  );
}

export default withTracker(Press);
